import { Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LobbyErrorCode } from 'src/app/infrastructure/lobby-proxy/enums/lobby-error-code.enum';

@Pipe({
    name: 'lobbyErrorMessage',
    pure: false,
    standalone: false
})
export class LobbyErrorMessagePipe extends TranslatePipe implements PipeTransform {

  override transform(value: LobbyErrorCode): string | undefined {
    if (!value) return undefined
    return super.transform('messages.lobbyError.' + LobbyErrorCode[value])
  }

} 